import Api from 'libs/api/index';

class PrestigeLevels extends Api {
  constructor() {
    super('admin/prestige_levels/');
  }
}

export default PrestigeLevels;
